




































































import { Component, Vue } from 'vue-property-decorator'
import { BCol, BRow } from 'bootstrap-vue'

@Component({ components: { BCol, BRow } })
export default class FooterSection extends Vue {}
